import styled from 'styled-components';
import { Stack } from 'components/Stack';

export const Container = styled(Stack).attrs({
  align: 'center',
  gap: 10,
})``;

export const IconContainer = styled.span`
  display: flex;
`;

export const OpeningContainer = styled.div<{ iconSize: number }>`
  padding-left: ${({ iconSize }) => 10 + iconSize}px;
`;

export const HoursContainer = styled(Stack).attrs({
  isFullWidth: true,
  direction: 'column',
  gap: 8,
})`
  &:not(:last-child) {
    margin-bottom: 20px;
  }
`;

export const Day = styled(Stack).attrs({ isFullWidth: true, gap: 8 })<{
  isToday: boolean;
}>`
  font-weight: ${({ isToday }) => (isToday ? 'bold' : 'inherit')};
`;

export const DayOfWeek = styled.div`
  min-width: 96px;
`;
